import "./AddBook.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddBookViewModel from "./AddBookViewModel";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import Select from "react-select";

const AddBook = () => {
  const {
    RegisterBook,
    AddBook,
    setAddBook,
    BookIDError,
    BookNameError,
    BookTypeError,
    BookStatusError,
    FormDisabled,
    IsUpdate,
  } = AddBookViewModel();
  const SchoolAddedResp = IsSchoolAdded();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid add-book-container">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate === true ? "Update Book" : "Add Book"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/admin/library`}>Library</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {IsUpdate === true ? "Update Book" : "Add Book"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Book Information</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            ID <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              BookIDError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddBook({
                                ...AddBook,
                                BookID: e.target.value,
                              });
                            }}
                            value={AddBook.BookID}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {BookIDError === true ? (
                            <span className="admin-add-book-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Material id is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-book-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Material id is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              BookNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddBook({
                                ...AddBook,
                                BookName: e.target.value.toLowerCase(),
                              });
                            }}
                            value={AddBook.BookName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {BookNameError === true ? (
                            <span className="admin-add-book-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Material name is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-book-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Material name is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Type <span className="login-danger">*</span>
                          </label>

                          <Select
                            className={`
                                  select-expense-type
                                  ${
                                    BookTypeError
                                      ? "select-expense-type-error"
                                      : ""
                                  } `}
                            onChange={(e) => {
                              setAddBook({
                                ...AddBook,
                                BookType: e.value,
                              });
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                            options={[
                              {
                                value: "rent",
                                label: "Select type",
                                isDisabled: true,
                              },
                              { value: "book", label: "Book" },
                              { value: "dvd", label: "DVD" },
                              { value: "cd", label: "CD" },
                              { value: "newspaper", label: "Newspaper" },
                              { value: "other", label: "Other" },
                            ]}
                            defaultValue={AddBook.BookType}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Status <span className="login-danger">*</span>
                          </label>

                          <Select
                            className={`
                                  select-expense-type
                                  ${
                                    BookStatusError
                                      ? "select-expense-type-error"
                                      : ""
                                  } `}
                            onChange={(e) => {
                              setAddBook({
                                ...AddBook,
                                BookStatus: e.value,
                              });
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                            options={[
                              {
                                value: "rent",
                                label: "Select status",
                                isDisabled: true,
                              },
                              { value: "in-stock", label: "In Stock" },
                              { value: "out-of-stock", label: "Out of Stock" },
                            ]}
                            defaultValue={AddBook?.BookStatus}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterBook();
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            {FormDisabled && <ButtonSpinner />}
                            {IsUpdate === true ? "Update " : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddBook;
